import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-icon-secondary hover:text-icon-hover cursor-pointer',
    icon: 'hover:[&>path]:stroke-icon-brand'
  },
  variants: {
    isActive: {
      true: {
        icon: 'fill-icon-brand [&>path]:stroke-icon-brand'
      }
    }
  }
});
